
export const parseExpiryDate = (expiryDateString: string) => {
  const [expiration_month, expiration_year] = expiryDateString.split("/");
  return {
    expiration_month,
    expiration_year
  }
}

